<template>
  <div class="overflow" style="padding-top: 30px;height: 100%;overflow:auto;">
    <el-row :key="item.id" class="templateRow" v-for="item in templateList">
      <el-row>
        {{ item.name }}
        <a @touchstart="openDialog(item)" @click="openDialog(item)" size="mini" style="color:#299FFB; cursor: pointer; float: right;" type="text">
          编辑
        </a>
      </el-row>
      <el-row>
        <div :data-clipboard-text="item.content" @touchstart="copy" @click="copy" class="copy content">{{ item.content }}</div>
        <div style="margin: 40px 0 0 10px">
          <el-row>
            <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="10">模板签名：</el-col>
            <el-col :lg="12" :md="12" :sm="12" :xl="20" :xs="11">
              <span v-if="item.noticeTemplateSetting !== null">{{
                  JSON.parse(item.noticeTemplateSetting.setting).signName
                }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px;">
            <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="10">模板编码：</el-col>
            <el-col :lg="12" :md="12" :sm="12" :xl="20" :xs="11">
              <span v-if="item.noticeTemplateSetting !== null">{{
                  JSON.parse(item.noticeTemplateSetting.setting).templateCode
                }}</span>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </el-row>


    <!--    弹出窗-->
    <function-dialog-component
      :dialogVisible.sync="dialogVisible"
      @dialogClose="(data) => this.dialogVisible = data"
      center
      :closeClick="false"
      :dialog-title="title"
      width="35vw">
      <div slot="content" style="padding: 20px 30px 20px 30px;height: 20vh">
        <el-row>
          <el-col :lg="9" :md="11" :sm="11" :xl="8" :xs="10" style="text-align: right;margin-right: 2%">模板签名：</el-col>
          <el-col :lg="10" :md="10" :sm="10" :xl="10" :xs="13">
            <el-input size="mini" v-model="signName"></el-input>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;">
          <el-col :lg="9" :md="11" :sm="11" :xl="8" :xs="10" style="text-align: right;margin-right: 2%">模板编码：</el-col>
          <el-col :lg="10" :md="10" :sm="10" :xl="10" :xs="13">
            <el-input size="mini" v-model="templateCode"></el-input>
          </el-col>
        </el-row>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 5px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.dialogVisible = false;}" @click="() => {this.dialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="commit" @click="commit" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {listByCategory, saveSetting, updateSetting} from "@/network/notice-template";
import Clipboard from 'clipboard';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";

export default {
  name: "Template",
  components: {FunctionDialogComponent},
  inject: ['overflow'],
  data() {
    return {
      category: "dcim_aliyun_sms",
      templateList: [],
      dialogVisible: false,
      params: {
        setting: "",
        templateId: "",
      },
      title: "",
      signName: "",
      templateCode: "",
    }
  },
  mounted() {
    this.overflow()
    this.listByCategory();
  },
  methods: {
    listByCategory() {
      listByCategory(this.category).then(res => {
        if (res.code === 0) {
          this.templateList = res.data
        }
      })
    },
    copy() {
      this.$message.success("复制成功!")
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        console.log('复制成功', e)
        //  释放内存
        clipboard.destory()
      })
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持复制', e)
        // 释放内存
        clipboard.destory()
      })
    },
    openDialog(item) {
      this.params = {
        setting: "",
        templateId: "",
      }
      this.title = "编辑" + item.name;
      this.signName = "";
      this.templateCode = "";
      this.params.templateId = item.id;
      if (item.noticeTemplateSetting) {
        this.params.id = item.noticeTemplateSetting.id;
        this.signName = JSON.parse(item.noticeTemplateSetting.setting).signName;
        this.templateCode = JSON.parse(item.noticeTemplateSetting.setting).templateCode;
      }
      this.dialogVisible = true;
    },
    commit() {
      const setting = {
        signName: this.signName,
        templateCode: this.templateCode
      }
      this.params.setting = JSON.stringify(setting);
      console.log(this.params);
      if (this.params.id) {
        this.updateSetting();
      } else {
        this.saveSetting();
      }
    },
    updateSetting() {
      updateSetting(this.params).then(res => {
        if (res.code === 0) {
          this.$message.success("编辑成功!")
        } else {
          this.$message.error("编辑失败!")
        }
        this.dialogVisible = false;
        this.listByCategory();
      })
    },
    saveSetting() {
      saveSetting(this.params).then(res => {
        if (res.code === 0) {
          this.$message.success("编辑成功!")
        } else {
          this.$message.error("编辑失败!")
        }
        this.dialogVisible = false;
        this.listByCategory();
      })
    },
  }
}
</script>

<style scoped>

.templateRow {
  height: 230px;
  margin: 0 30px 20px 30px;
  background-color: rgba(64, 166, 231, 0.07);
  padding: 25px;
}

.templateRow .content {
  margin: 10px 0 10px 0;
  font-size: 0.9rem;
  color: #d4d2d2;
}

.content:hover {
  cursor: pointer;
  color: #fff;
}
</style>
